
import { Component, Vue, Watch } from 'vue-property-decorator';
import VWidget from '@/components/VWidget.vue';
import Ajax from '@/lib/ajax';
import Util from '@/lib/util';

@Component({ components: { VWidget } })
export default class CampaignManagementView extends Vue {
    loading = false; saving = false; dialog = false; valid = false;
    statusWarning = '';
    campaignVins: any[] = []; vinSummary: any = { total: 0, worked: 0, pending: 0, incomplete: 0, compliance: 0, has_bulk_images: false };
    selectedMasterVin: any = null; masterVinMatches: any[] = []; masterVinSearch = '';
    searchingMaster = false; vinsLoading = false; campaignVinFilter = '';
    campaignVinFile: File | null = null; importingCampaignVins = false; masterSearchTimer: any = null;
    dealers: any[] = []; vinWorkDialog = false; vinWorkValid = false; savingVinWork = false;
    vinWork: any = { id: null, vin: '', service_dealer_id: null, reviewed: false, result: null, mileage: null, images: [], newImages: [] };
    detailTab = 0; parts: any[] = []; partsLoading = false; savingPart = false;
    confirmationDialog = false; confirmationTitle = ''; confirmationText = ''; confirmationButtonText = '';
    confirmationResolver: ((confirmed: boolean) => void) | null = null;
    partForm: any = { code: '', description: '', quantity: 1 };
    campaigns: any[] = []; manufacturers: any[] = []; models: any[] = [];
    filters: any = { search: null, vin: null, status: null, manufacturer_id: null, date_from: null, date_to: null };
    form: any = this.emptyForm();
    required = [(value: any) => !!value || 'Campo obligatorio'];
    emailRules = [(value: string) => !value || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || 'Ingrese un correo valido'];
    atLeastOne = [(value: any[]) => (value && value.length > 0) || 'Seleccione al menos un modelo'];
    types = [{ text: 'Fábrica', value: 'factory' }, { text: 'Local', value: 'local' }];
    statuses = [{ text: 'Pendiente', value: 'pending' }, { text: 'Iniciado', value: 'started' }, { text: 'Finalizado', value: 'finished' }];
    results = [{ text: 'Sí', value: 'yes' }, { text: 'No', value: 'no' }, { text: 'No aplica', value: 'not_applicable' }];
    headers = [
        { text: 'Nombre de campaña', value: 'name' }, { text: 'Código fábrica', value: 'factory_code' },
        { text: 'Código AASA', value: 'aasa_code' }, { text: 'Marca', value: 'manufacturer.name' },
        { text: 'Total', value: 'vins_count' }, { text: 'Trabajadas', value: 'worked_count' },
        { text: 'Faltantes', value: 'pending_count' }, { text: 'Cumplimiento', value: 'compliance' },
        { text: 'Estado', value: 'status' }, { text: 'Acciones', value: 'actions', sortable: false },
    ];
    vinHeaders = [
        { text: 'VIN', value: 'vin' }, { text: 'Fecha de venta', value: 'sale_date' },
        { text: 'Vendido por', value: 'sold_by' }, { text: 'Taller de atención', value: 'service_dealer' },
        { text: 'Modelo', value: 'model' }, { text: 'Revisado', value: 'reviewed' },
        { text: 'Realizado', value: 'result' }, { text: 'Imágenes', value: 'images', sortable: false },
        { text: 'Kilometraje', value: 'mileage' }, { text: 'Acciones', value: 'actions', sortable: false },
    ];
    partHeaders = [
        { text: 'Código de repuesto', value: 'code' }, { text: 'Descripción', value: 'description' },
        { text: 'Cantidad', value: 'quantity' }, { text: 'Acciones', value: 'actions', sortable: false },
    ];
    get isDealer() { return Util.abp.session.isDealer(); }
    get canManageCampaigns() { return Util.abp.session.isAdmin || Util.abp.auth.hasPermission('Campaigns.Management.manage'); }
    get canAddCampaignVins() { return this.canManageCampaigns && ['pending', 'started'].includes(this.form.status); }
    get canEditVinWork() { return (this.isDealer && this.form.status === 'started') || (this.canManageCampaigns && ['pending', 'started'].includes(this.form.status)); }
    get availableModels() { return this.models.filter((item: any) => Number(item.manufacturer_id) === Number(this.form.manufacturer_id)); }
    get documentRules() { return [(value: File[]) => (value && value.length > 0) || this.form.has_document || 'Adjunte al menos un documento de la campaña']; }
    get vinImageRules() { return [(value: File[]) => this.form.type !== 'factory' || (value && value.length > 0) || this.vinWork.images.length > 0 || 'Adjunte al menos una imagen']; }
    emptyForm() { return { id: null, name: '', factory_code: '', aasa_code: '', type: 'factory', start_date: '', manufacturer_id: null, model_ids: [], details: '', opco: '', labor_time: null, hours: null, claim: '', email: '', documents: [], existing_documents: [], document_name: null, has_document: false }; }
    async created() { try { const options = await Ajax.get('/api/campaign-options'); this.manufacturers = options.data.result.manufacturers; this.models = options.data.result.models; this.dealers = options.data.result.dealers.map((item: any) => ({ ...item, display_name: `${item.name}${item.location ? ' - ' + item.location : ''}` })); await this.load(); } catch (_) { this.manufacturers = []; this.models = []; this.dealers = []; } }
    async load() { this.loading = true; try { const response = await Ajax.get('/api/campaigns', { params: { ...this.filters, perPage: 100 } }); this.campaigns = response.data.result.data; } finally { this.loading = false; } }
    openNew() { this.form = this.emptyForm(); this.statusWarning = ''; this.dialog = true; }
    async openEdit(item: any) { const response = await Ajax.get(`/api/campaigns/get/${item.id}`); const data = response.data.result; this.form = { ...this.emptyForm(), ...data, documents: [], existing_documents: data.documents || [], start_date: data.start_date.substr(0, 10) }; this.detailTab = 0; this.statusWarning = ''; this.dialog = true; await Promise.all([this.loadCampaignVins(), this.loadParts()]); }
    async save() {
        if (!(this.$refs.form as any).validate()) {
            Util.abp.notify.error(this, 'Complete los campos obligatorios de Informacion general');
            return;
        }
        const isEditing = !!this.form.id;
        this.saving = true;
        try {
            const data = new FormData();
            Object.keys(this.form).forEach(key => {
                if (['id', 'model_ids', 'documents', 'existing_documents', 'document_name', 'has_document'].includes(key)) return;
                const value = this.form[key];
                if (value !== null && value !== undefined) data.append(key, value);
            });
            this.form.model_ids.forEach((id: number) => data.append('model_ids[]', String(id)));
            (this.form.documents || []).forEach((file: File) => data.append('documents[]', file));
            if (this.form.id) data.append('_method', 'PUT');
            const response = await Ajax.post(this.form.id ? `/api/campaigns/${this.form.id}` : '/api/campaigns', data);
            if (!this.form.id) {
                const campaign = response.data.result;
                this.form = { ...this.form, ...campaign, documents: [], existing_documents: campaign.documents || [], start_date: campaign.start_date.substr(0, 10) };
                await Promise.all([this.loadCampaignVins(), this.loadParts()]);
            } else this.dialog = false;
            await this.load();
            Util.abp.notify.success(this, isEditing ? 'Campaña actualizada correctamente' : 'Campaña creada correctamente');
        } finally { this.saving = false; }
    }
    async downloadDocument(document: any) {
        await this.downloadAuthenticated(`/api/campaigns/${this.form.id}/documents/${document.id}`, document.original_name || 'documento-campana');
    }
    async downloadLegacyDocument() {
        await this.downloadAuthenticated(`/api/campaigns/${this.form.id}/document`, this.form.document_name || 'documento-campana');
    }
    async removeDocument(document: any) {
        if (!await this.confirmAction('¿Eliminar documento?', document.original_name, 'Eliminar')) return;
        await Ajax.delete(`/api/campaigns/${this.form.id}/documents/${document.id}`);
        this.form.existing_documents = this.form.existing_documents.filter((item: any) => item.id !== document.id);
        Util.abp.notify.success(this, 'Documento eliminado correctamente');
    }
    async downloadAuthenticated(path: string, filename: string) {
        try {
            const baseUrl = String((Ajax.defaults as any).baseURL || '').replace(/\/+$/, '');
            const response = await fetch(`${baseUrl}/${path.replace(/^\/+/, '')}`, {
                headers: {
                    Accept: 'application/json, application/octet-stream',
                    Authorization: `Bearer ${window.abp.auth.getToken()}`,
                },
            });
            if (!response.ok) {
                let message = 'No se pudo descargar el archivo';
                try {
                    const error = await response.json();
                    message = error.message || (error.error && error.error.message) || message;
                } catch (_) { /* La respuesta puede no ser JSON. */ }
                throw new Error(message);
            }

            const blob = await response.blob();
            const objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = filename;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            link.remove();

            // Chrome necesita que la URL siga disponible hasta iniciar la descarga.
            window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
        } catch (error) {
            const message = error instanceof Error ? error.message : 'No se pudo descargar el archivo';
            Util.abp.notify.error(this, message);
        }
    }
    async loadCampaignVins() {
        if (!this.form.id) return;
        this.vinsLoading = true;
        try {
            const response = await Ajax.get(`/api/campaigns/${this.form.id}/vins`, { params: { vin: this.campaignVinFilter } });
            this.campaignVins = response.data.result.items.data;
            this.vinSummary = response.data.result.summary;
        } finally { this.vinsLoading = false; }
    }
    async addCampaignVin() {
        await Ajax.post(`/api/campaigns/${this.form.id}/vins`, { vin: this.selectedMasterVin.vin });
        this.selectedMasterVin = null; this.masterVinSearch = ''; this.masterVinMatches = [];
        await this.loadCampaignVins();
        Util.abp.notify.success(this, 'VIN agregado correctamente');
    }
    async importCampaignVins() {
        if (!this.campaignVinFile) return;
        this.importingCampaignVins = true;
        try {
            const data = new FormData(); data.append('file', this.campaignVinFile);
            const response = await Ajax.post(`/api/campaigns/${this.form.id}/vins/import`, data);
            const result = response.data.result;
            Util.abp.notify.success(this, `${result.created} VIN agregados y ${result.existing} existentes actualizados`);
            this.campaignVinFile = null; await this.loadCampaignVins();
        } finally { this.importingCampaignVins = false; }
    }
    async downloadCampaignVinTemplate() { await this.downloadAuthenticated(`/api/campaigns/${this.form.id}/vins/template`, 'plantilla-vins-campana.xlsx'); }
    async removeCampaignVin(item: any) {
        if (!await this.confirmAction('¿Eliminar VIN?', item.vin, 'Eliminar')) return;
        await Ajax.delete(`/api/campaigns/${this.form.id}/vins/${item.id}`);
        await this.loadCampaignVins();
        Util.abp.notify.success(this, 'VIN eliminado correctamente');
    }
    openVinWork(item: any) {
        if (!this.canEditVinWork) return;
        this.vinWork = { ...item, newImages: [], images: item.images || [] };
        this.vinWorkDialog = true;
    }
    async saveVinWork() {
        if (!(this.$refs.vinWorkForm as any).validate()) return;
        this.savingVinWork = true;
        try {
            const data = new FormData();
            data.append('service_dealer_id', String(this.vinWork.service_dealer_id));
            data.append('reviewed', this.vinWork.reviewed ? '1' : '0');
            data.append('result', this.vinWork.result);
            data.append('mileage', String(this.vinWork.mileage));
            (this.vinWork.newImages || []).forEach((file: File) => data.append('images[]', file));
            await Ajax.post(`/api/campaigns/${this.form.id}/vins/${this.vinWork.id}/work`, data);
            this.vinWorkDialog = false; await this.loadCampaignVins();
            Util.abp.notify.success(this, 'Atención del VIN guardada correctamente');
        } finally { this.savingVinWork = false; }
    }
    async downloadVinImage(image: any) { await this.downloadAuthenticated(`/api/campaigns/${this.form.id}/vins/${this.vinWork.id}/images/${image.id}`, image.original_name); }
    async removeVinImage(image: any) {
        if (!await this.confirmAction('¿Eliminar imagen?', image.original_name, 'Eliminar')) return;
        await Ajax.delete(`/api/campaigns/${this.form.id}/vins/${this.vinWork.id}/images/${image.id}`);
        this.vinWork.images = this.vinWork.images.filter((item: any) => item.id !== image.id);
        await this.loadCampaignVins();
        Util.abp.notify.success(this, 'Imagen eliminada correctamente');
    }
    async loadParts() {
        if (!this.form.id) return;
        this.partsLoading = true;
        try { const response = await Ajax.get(`/api/campaigns/${this.form.id}/parts`); this.parts = response.data.result; }
        finally { this.partsLoading = false; }
    }
    async addPart() {
        this.savingPart = true;
        try {
            await Ajax.post(`/api/campaigns/${this.form.id}/parts`, this.partForm);
            this.partForm = { code: '', description: '', quantity: 1 };
            await this.loadParts();
            Util.abp.notify.success(this, 'Repuesto agregado correctamente');
        } finally { this.savingPart = false; }
    }
    async removePart(item: any) {
        if (!await this.confirmAction('¿Eliminar repuesto?', item.code, 'Eliminar')) return;
        await Ajax.delete(`/api/campaigns/${this.form.id}/parts/${item.id}`);
        await this.loadParts();
        Util.abp.notify.success(this, 'Repuesto eliminado correctamente');
    }
    async downloadFilteredCampaigns() {
        const query = Object.keys(this.filters)
            .filter(key => this.filters[key] !== null && this.filters[key] !== '')
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(this.filters[key])}`)
            .join('&');
        await this.downloadAuthenticated(`/api/campaigns-download${query ? '?' + query : ''}`, 'campanas-filtradas.xlsx');
    }
    async downloadCampaignVins() {
        const query = this.campaignVinFilter ? `?vin=${encodeURIComponent(this.campaignVinFilter)}` : '';
        await this.downloadAuthenticated(`/api/campaigns/${this.form.id}/download-vins${query}`, `campana-${this.form.aasa_code}-vins.xlsx`);
    }
    async downloadCampaignImages() { await this.downloadAuthenticated(`/api/campaigns/${this.form.id}/vin-images`, `campana-${this.form.aasa_code}-imagenes.zip`); }
    async changeStatus(action: 'start' | 'finish' | 'reopen') {
        if (action === 'finish' && this.vinSummary.incomplete > 0) {
            this.statusWarning = `No se puede finalizar. Hay ${this.vinSummary.incomplete} VIN con información incompleta. Todos deben tener taller, resultado, kilometraje y la evidencia requerida.`;
            return;
        }
        this.statusWarning = '';
        const settings = {
            start: { title: '¿Iniciar campaña?', text: 'La campaña será visible para los dealers.', button: 'Iniciar', success: 'Campaña iniciada correctamente' },
            finish: { title: '¿Finalizar campaña?', text: 'La campaña quedará en modo de solo lectura.', button: 'Finalizar', success: 'Campaña finalizada correctamente' },
            reopen: { title: '¿Reabrir campaña?', text: 'La campaña volverá al estado iniciado.', button: 'Reabrir', success: 'Campaña reabierta correctamente' },
        }[action];
        if (!await this.confirmAction(settings.title, settings.text, settings.button)) return;
        try {
            const response = await Ajax.post(`/api/campaigns/${this.form.id}/${action}`);
            this.form.status = response.data.result.status;
            await Promise.all([this.load(), this.loadCampaignVins()]);
            Util.abp.notify.success(this, settings.success);
        } catch (error) {
            if (action !== 'finish') throw error;
            const response = (error as any).response;
            this.statusWarning = response && response.data && response.data.message
                ? response.data.message
                : 'No se puede finalizar la campaña porque existen VIN con información incompleta.';
        }
    }
    async searchMasterVins(value: string) {
        if (!value || value.length < 2) { this.masterVinMatches = []; return; }
        this.searchingMaster = true;
        try { const response = await Ajax.get('/api/campaign-vin-master-search', { params: { vin: value } }); this.masterVinMatches = response.data.result; }
        finally { this.searchingMaster = false; }
    }
    @Watch('masterVinSearch')
    onMasterVinSearch(value: string) {
        clearTimeout(this.masterSearchTimer);
        this.masterSearchTimer = setTimeout(() => this.searchMasterVins(value), 300);
    }
    async confirmAction(title: string, text: string, confirmButtonText: string) {
        this.confirmationTitle = title;
        this.confirmationText = text;
        this.confirmationButtonText = confirmButtonText;
        this.confirmationDialog = true;
        return new Promise<boolean>((resolve) => { this.confirmationResolver = resolve; });
    }
    resolveConfirmation(confirmed: boolean) {
        this.confirmationDialog = false;
        if (this.confirmationResolver) this.confirmationResolver(confirmed);
        this.confirmationResolver = null;
    }
    async remove(item: any) {
        if (!await this.confirmAction('¿Eliminar campaña?', item.name, 'Eliminar')) return;
        await Ajax.delete(`/api/campaigns/${item.id}`);
        await this.load();
        Util.abp.notify.success(this, 'Campaña eliminada correctamente');
    }
    complianceColor(value: number) { return value < 50 ? 'red' : value < 80 ? 'amber darken-2' : 'green'; }
    statusColor(value: string) { return value === 'pending' ? 'grey' : value === 'started' ? 'green' : 'blue'; }
    statusText(value: string) { const item = this.statuses.find(status => status.value === value); return item ? item.text : value; }
    resultText(value: string) { const item = this.results.find(result => result.value === value); return item ? item.text : '-'; }
}
